function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import classNames from 'classnames';
import React, { useMemo } from 'react';
const CircularButton = ({
  children,
  className,
  ...props
}) => {
  const buttonClassNames = useMemo(() => classNames(`${className ?? ''}`, 'inline-flex', 'items-center', 'border', 'border-transparent', 'rounded-full', 'shadow-md', 'focus:outline-none', 'focus:ring-2', 'focus:ring-offset-2', 'focus:ring-indigo-500'), [className]);
  return /*#__PURE__*/React.createElement("button", _extends({
    type: "button",
    className: buttonClassNames
  }, props), children);
};
export default CircularButton;